import localStore from 'local-storage';
import createTrackingClient from '@seek/seek-impression-tracking';
import { jobTrackingEnabled, jobTrackingUrl } from 'config';
import { parse as parseCookies } from 'cookie';

const JOB_TRACKING_LOCAL_STORAGE_KEY = 'job-tracking';

const createLocalEventStore = () => {
  const store = {
    swap: f => {
      store.set(f(store.get()));
    },
    set: value => {
      localStore.set(JOB_TRACKING_LOCAL_STORAGE_KEY, JSON.stringify(value));
    },
    get: () => {
      return JSON.parse(localStore.get(JOB_TRACKING_LOCAL_STORAGE_KEY));
    }
  };

  return store;
};

const sessionId = ENV.CLIENT ? parseCookies(document.cookie).JobseekerSessionId : null;
const trackingClient = (ENV.CLIENT && jobTrackingEnabled) ?
                       createTrackingClient(jobTrackingUrl, {
                         store: createLocalEventStore(),
                         params: sessionId ? { sessionId } : null
                       }) :
                       {};

const {
  trackJobImpression = () => {},
  trackJobImpressionExit = () => {},
  trackJobClick = () => {},
  forceTrackingRequest = () => {},
  serializeUnsentImpressions = () => {}
} = trackingClient;

export {
  trackJobImpression,
  trackJobImpressionExit,
  trackJobClick,
  forceTrackingRequest,
  serializeUnsentImpressions
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/job-tracking/index.js
 **/